module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"deleteVacancyList":"Страница с подборкой вакансий будет удалена, а QR-код перестанет работать.","delete":"Удалить","cancel":"Отмена"}}')
  delete Component.options._Ctor
}
